import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
import EventFAQSummary from 'shared-components/faq/EventFAQSummary';

const EventFAQBookingSummary = ({ faqData, openModal }) => {
  return (
    <>
      <EventFAQSummary faqData={faqData} />
      <hr />
      <div className="text-center text-gray-dark text-small">
        <FormattedMessage
          id='inbox_guest_update_booking.booking_summary.footer_event_faq_copy'
          defaultMessage='Have more questions? {eventFAQLink}'
          values={{
            eventFAQLink: (
              <a
                onClick={openModal}
                className="text-bold text-gray-dark underline"
              >
                <FormattedMessage
                  id="inbox_guest_update_booking.booking_summary.footer_event_faq_link"
                  defaultMessage="View the entire FAQ"
                />
              </a>
            )
          }}
        />
      </div>
    </>
  );
};

EventFAQBookingSummary.propTypes = {
  faqData: PropTypes.object.isRequired,
  openModal: PropTypes.func,
  intl: intlShape
};

export default injectIntl(EventFAQBookingSummary);
